/*
 *
 * GroupedRadioSelector
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 19-Jun-2025
*/

import GroupedRadioSelector from './GroupedRadioSelectorContainer'

export default GroupedRadioSelector
